document.addEventListener('DOMContentLoaded', function(event) {
    initialiseColorSwatch();
});

function initialiseColorSwatch() {
  const radios = document.querySelectorAll('.custom-radio');
  const pdpTitleElement =  document.querySelector('.color-swatch__selected-title');
  radios.forEach(radio => {
    //radio.nextElementSibling.style.backgroundColor = radio.value;
    radio.addEventListener('change', (e) => {
      if (e.target.checked) {
        let title = e.target.getAttribute('data-title');
        let imageUrl = e.target.getAttribute('data-image');
        let price = e.target.getAttribute('data-variant-price');
        let comparePrice = e.target.getAttribute('data-variant-compare-price');
        let savingsPercentage = e.target.getAttribute('data-savings-percentage');
        let swatch = e.target.closest('.color-swatch');
        let selectedVariantId = e.target.value;


        let fragranceTemplate = document.getElementById('fragrance-product');
        let consolidatedTemplate = document.getElementById('consolidated-pdp');

        if(fragranceTemplate || consolidatedTemplate) {
          fetch(`${swatch.dataset.url}?variant=${selectedVariantId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            updateVariantImage(imageUrl);

            // Update Fragrance Variants 

            let fragranceBanner = document.querySelector('.section-container-fragrance-banner');
            let fragranceBannerSource = html.querySelector('.section-container-fragrance-banner');

            if(fragranceBanner && fragranceBannerSource){
              fragranceBanner.innerHTML = fragranceBannerSource.innerHTML;
            }

            let fragranceReviews = document.querySelector('.section-container-fragrance-reviews');
            let fragranceReviewsSource = html.querySelector('.section-container-fragrance-reviews');

            if(fragranceReviews && fragranceReviewsSource){
              fragranceReviews.innerHTML = fragranceReviewsSource.innerHTML;
              let fragranceReviewsCarousel = fragranceReviews.querySelector('.fragrance-reviews__content-container');
              
              if(fragranceReviewsCarousel) {
                initScrollCarousel(fragranceReviewsCarousel);
              }
            }

            let fragranceNotes = document.querySelector('.section-container-fragrance-notes');
            let fragranceNotesSource = html.querySelector('.section-container-fragrance-notes');

            if(fragranceNotes && fragranceNotesSource){
              fragranceNotes.innerHTML = fragranceNotesSource.innerHTML;
            }

            let fragranceFeatures = document.querySelector('.section-container-fragrance-features');
            let fragranceFeaturesSource = html.querySelector('.section-container-fragrance-features');

            if(fragranceFeatures && fragranceFeaturesSource){
              fragranceFeatures.innerHTML = fragranceFeaturesSource.innerHTML;
            }

            let fragranceGallery = document.querySelector('.product-single__gallery-container');
            let fragranceGallerySource = html.querySelector('.product-single__gallery-container');

            if(fragranceGallery && fragranceGallerySource){
              fragranceGallery.innerHTML = fragranceGallerySource.innerHTML;

            }
          });
        }

        // return;

        if(e.target.closest('#productSingle')) {
          window.history.replaceState({ }, '', `?variant=${selectedVariantId}`);
          e.target.closest('#productSingle').querySelector('.product-single__price [data-product-price]').innerText = price;
          document.querySelector('.product-form input[name="id"]').value = event.target.value;
          pdpTitleElement.innerText = title;
          updateVariantImage(imageUrl);
          toggleAddButton(e.target);
          if(comparePrice.length > 0) {
            e.target.closest('#productSingle').querySelector('.product-single__price [data-compare-price]').classList.remove('hidden');
            e.target.closest('#productSingle').querySelector('.product-single__price [data-compare-price]').innerText = comparePrice;
          }
          if(comparePrice.length === 0) {
            e.target.closest('#productSingle').querySelector('.product-single__price [data-compare-price]').classList.add('hidden');
          }
          if(savingsPercentage.length > 1) {
            e.target.closest('#productSingle').querySelector('.product-single__price .product-savings-badge').classList.remove('hidden');
             e.target.closest('#productSingle').querySelector('.product-single__price [data-savings-badge-percentage]').innerText = savingsPercentage;
          }
          if(savingsPercentage.length === 1) {
             e.target.closest('#productSingle').querySelector('.product-single__price .product-savings-badge').classList.add('hidden');
          }
        }

        if(e.target.closest('.product-grid-item')) {
          updateCollectionVariantImage(e.target.closest('.product-grid-item'), imageUrl);
          e.target.closest('.product-grid-item').querySelector('.product-grid-item__price [data-product-price]').innerText = price;
          e.target.closest('.product-grid-item').querySelector('.product-form input[name="id"]').value = event.target.value;
          e.target.closest('.product-grid-item').querySelector('.mobile-form-container .product-form input[name="id"]').value = event.target.value;
          e.target.closest('.product-grid-item').querySelector('.color-swatch__selected-title').innerText = title;
          if(comparePrice.length > 0) {
            e.target.closest('.product-grid-item').querySelector('.product-grid-item__price [data-compare-price]').innerText = comparePrice;
            e.target.closest('.product-grid-item').querySelector('.product-grid-item__price [data-compare-price]').classList.remove('hidden');
          }
          if(comparePrice.length === 0) {
            let comparePriceElement = e.target.closest('.product-grid-item').querySelector('.product-grid-item__price [data-compare-price]')
            if(comparePriceElement) {
              comparePriceElement.classList.add('hidden');
            }
          }
          if(savingsPercentage.length > 1) {
            e.target.closest('.product-grid-item').querySelector('.product-grid-item__price .product-savings-badge').classList.remove('hidden');
            e.target.closest('.product-grid-item').querySelector('.product-grid-item__price [data-savings-badge-percentage]').innerText = savingsPercentage;
          }
          if(savingsPercentage.length === 1) {
            let savingsBadge = e.target.closest('.product-grid-item').querySelector('.product-grid-item__price .product-savings-badge')
            if(savingsBadge) {
              savingsBadge.classList.add('hidden');
            }
          }
        
          if(e.target.closest('label').classList.contains('unavailable')) {
            e.target.closest('.product-grid-item').querySelector('[data-color-unavailable]').style.display = 'block';
          }
          else {
            e.target.closest('.product-grid-item').querySelector('[data-color-unavailable]').style.display = 'none';
          }
        }
        // e.target.nextElementSibling.style.border = '2px solid black';
      } else {
        // e.target.nextElementSibling.style.border = 'none';
      }
    });
  });

  function updateVariantImage(imageUrl) {
    // for mobile
    var pdpGalleryFirstThumbnail = document.querySelector('.product-single__thumbnails .thumbnail__catalogue-image img');
    var pdpGalleryFirstImg = document.querySelectorAll('#productSingleGallery .swiper-wrapper .main-gallery__catalogue-image img');
    if(pdpGalleryFirstImg && pdpGalleryFirstThumbnail) {
      pdpGalleryFirstThumbnail.src = imageUrl;
      pdpGalleryFirstImg.forEach(img => {
        img.src = imageUrl;
        img.srcset = imageUrl;
      });
    }

    // for desktop
    let desktopMainImage = document.querySelector('.product-single__main-image img');
    if(desktopMainImage) {
      desktopMainImage.src = imageUrl;
    }
  }

  function updateCollectionVariantImage(item, imageUrl) {
    let imageElement = item.querySelector('.product-grid-item__image .responsive-image');
    if(imageElement) {
      imageElement.src = imageUrl;
      imageElement.srcset = imageUrl;
    }
  }

  const radioLabels = document.querySelectorAll('.color-swatch label');
  let selectedLabel;
  radioLabels.forEach(label => {
    label.addEventListener("mouseover", (event) => {
      let title = label.querySelector('.custom-radio').getAttribute('data-title');
      document.querySelector('.color-swatch__selected-title').innerText = title;
    });

    label.addEventListener("mouseout", (event) => {
      let title = document.querySelector('.color-swatch .custom-radio:checked').getAttribute('data-title');
      document.querySelector('.color-swatch__selected-title').innerText = title;
    });
  });
}

function toggleAddButton(radio) {
    let container = radio.closest('.product-single__content');
    const addButton = container.querySelector('.main-product__form #addToCart');
    const formButtons = container.querySelector('.product-form__buttons');
    const stickyFormButtons = document.querySelector('.product-sticky-form__form  .product-form__buttons');
    const stickyFormAddButton = document.querySelector('.product-sticky-form__form')?.querySelector('[name="add"]');
    const klaviyoBisTrigger = document.querySelector('#productSingle .main-product__form .klaviyo-bis-trigger');
    const stickyFormKlaviyoBisTrigger = document.querySelector('.product-sticky-form__form .klaviyo-bis-trigger');

    let variants = JSON.parse(container.querySelector('[type="application/json"]').textContent);
    let currentVariantId = radio.value;
    let currentVariant = variants.find(function(variant) {
      return variant.id == currentVariantId;
    });

    if(currentVariant.available){
      formButtons ? formButtons.classList.remove('sold-out') : '' ;
      stickyFormButtons ? stickyFormButtons.classList.remove('sold-out') : '' ;
      
      addButton ? addButton.style.display = 'inline-block' : '' ;
      stickyFormAddButton ? stickyFormAddButton.style.display = 'inline-block' : '' ;
      klaviyoBisTrigger ? klaviyoBisTrigger.classList.remove('klaviyo-bis--active') : '' ;
      stickyFormKlaviyoBisTrigger ? stickyFormKlaviyoBisTrigger.classList.remove('klaviyo-bis--active') : '' ;
    } else{
      formButtons ? formButtons.classList.add('sold-out') : '' ;
      stickyFormButtons ? stickyFormButtons.classList.add('sold-out') : '' ;
      
      addButton ? addButton.style.display = 'none' : '' ;
      stickyFormAddButton ? stickyFormAddButton.style.display = 'none' : '' ;
      klaviyoBisTrigger ? klaviyoBisTrigger.classList.add('klaviyo-bis--active') : '' ;
      stickyFormKlaviyoBisTrigger ? stickyFormKlaviyoBisTrigger.classList.add('klaviyo-bis--active') : '' ;
    }
  }